import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import FilmCard from "../components/FilmCard";
import api from "../api/client";
import { Bookmark } from "lucide-react";

export default function Watchlist() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/watchlist");
                setItems(data);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <section className="max-w-[1400px] mx-auto px-4 md:px-10 pt-14 pb-28">
                <div className="flex items-center gap-3 mb-3 text-[11px] tracking-[0.3em] text-silver-400 uppercase">
                    <Bookmark className="w-4 h-4" /> Your Watchlist
                </div>
                <h1 className="font-display text-5xl md:text-6xl leading-none mb-10">
                    Films you're <span className="silver-text italic">tracking.</span>
                </h1>
                {loading ? (
                    <div className="text-silver-500">Loading…</div>
                ) : items.length === 0 ? (
                    <div className="text-silver-500">Your watchlist is empty. Add titles from the <a className="underline" href="/catalog">Marketplace</a>.</div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="watchlist-grid">
                        {items.map((it) => <FilmCard key={it.film.id} film={it.film} />)}
                    </div>
                )}
            </section>
        </div>
    );
}
